module.exports = __webpack_public_path__ + "img/menu1.95a7a89b.png";